import { IItemCategory } from "src/app/site/feature-modules/home/shared/components/item-categories-menu/models/item-categories.model";

export class GetItemCategroy {
    static readonly type = '[ItemCategroy] GetAll';
}

export class AddItemCategroy {
    static readonly type = '[ItemCategroy] Add';
    constructor(public payload: IItemCategory | null) {
    }
}